import * as msal from "@azure/msal-browser"
import { msalConfig, loginRequest, tokenRequest } from "./config";
import admin from "@/apiCallers/promise_handler_db/admin";
import { store } from '@/vuex/store'
import { clearAllParams } from "../../router/queryHandler/index"
// Create the main myMSALObj instance
// configuration parameters are located at authConfig.js

console.log(msalConfig)
const myMSALObj = new msal.PublicClientApplication(msalConfig);

let username = "";

/**
 * A promise handler needs to be registered for handling the
 * response returned from redirect flow. For more information, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/acquire-token.md
 */
myMSALObj.handleRedirectPromise()
    .then(handleResponse)
    .catch((error) => {
        console.error(error);
    });


function isLoggedIn() {
    const currentAccounts = myMSALObj.getAllAccounts();
    console.log(currentAccounts)
    return currentAccounts.length > 0;
}

function selectAccount() {

    /**
     * See here for more info on account retrieval: 
     * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-common/docs/Accounts.md
     */

    const currentAccounts = myMSALObj.getAllAccounts();

    if (currentAccounts.length === 0) {
        return;
    } else if (currentAccounts.length > 1) {
        // Add your account choosing logic here
        console.warn("Multiple accounts detected.");
    } else if (currentAccounts.length === 1) {
        username = currentAccounts[0].username;
        // showWelcomeMessage(username);
    }
}

async function handleResponse(response) {
    if (response !== null) {
        store.state.login_load = true;
        store.state.aToken = response.accessToken;
        await admin.logUserLogin(response.uniqueId)
            .catch((er) => {
                console.error("Unable to log user login");
            }).then((resp) => {
                username = response.account.username;
                console.log(resp)
                window.location.href = resp.data
            });

    } else {
        selectAccount();
    }
}

async function signIn() {

    /**
     * You can pass a custom request object below. This will override the initial configuration. For more information, visit:
     * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/request-response-object.md#request
     */

    clearAllParams();
    await myMSALObj.loginRedirect(loginRequest).then((resp) => {
        // location.href("http://localhost:8080/")
    })
}

function signOut() {

    /**
     * You can pass a custom request object below. This will override the initial configuration. For more information, visit:
     * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/request-response-object.md#request
     */

    clearAllParams();

    const logoutRequest = {
        account: myMSALObj.getAccountByUsername(username),
        postLogoutRedirectUri: msalConfig.auth.redirectUri,
    };

    myMSALObj.logout(logoutRequest);
}

function getTokenRedirect() {
    /**
     * See here for more info on account retrieval: 
     * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-common/docs/Accounts.md
     */
    let request = tokenRequest;
    selectAccount();
    request.account = myMSALObj.getAccountByUsername(username);

    return myMSALObj.acquireTokenSilent(request)
        .catch((error) => {
            console.warn("silent token acquisition fails. acquiring token using redirect");
            if (error instanceof msal.InteractionRequiredAuthError) {
                // fallback to interaction when silent call fails
                return myMSALObj.acquireTokenRedirect(request);
            } else {
                console.warn(error);
            }
        });
}

function seeProfile() {
    getTokenRedirect(loginRequest)
        .then(response => {
            // callMSGraph(graphConfig.graphMeEndpoint, response.accessToken, updateUI);
        }).catch(error => {
            console.error(error);
        });
}


function readMail() {
    getTokenRedirect(tokenRequest)
        .then(response => {
            callMSGraph(graphConfig.graphMailEndpoint, response.accessToken, updateUI);
        }).catch(error => {
            console.error(error);
        });
}
export { signIn, getTokenRedirect, isLoggedIn, signOut }